import React, { useMemo } from 'react';
import { Link } from '@components/shared/NavigationBar/NavBarLinkItem';
import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';

export interface MenuItemProps {
  link: Link;
  type: MenuItemType;
  contentBefore?: React.ReactNode;
  contentAfter?: React.ReactNode;
}

export type MenuItemType = 'profile' | 'subMenu' | 'menuItem';

export const MenuItem: React.FC<MenuItemProps> = ({ link, type, contentBefore, contentAfter }) => {
  const { href, onClick, text } = link;

  const isActive = useMemo(() => (href && globalThis ? globalThis.location.pathname === href : false), [href]);

  return (
    <a css={menuLinkStyles} href={href} onClick={onClick}>
      <li css={[menuItemContainerBaseStyles, menuItemContainerStyles[type], isActive && activeStyles]} role="treeitem">
        {contentBefore}
        {text}
        {contentAfter}
      </li>
    </a>
  );
};

const menuItemContainerBaseStyles = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});

const menuItemContainerStyles = {
  subMenu: css({
    height: '32px',
    padding: '0 40px',
  }),
  profile: css({
    height: '48px',
    padding: '0 24px',
  }),
  menuItem: css({
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 400,
    height: '32px',
    padding: `0 ${token('space.150')}`,
  }),
};

const menuLinkStyles = css({
  fontSize: '16px',
  lineHeight: '16px',
  fontWeight: 400,
  color: '#172B4D',
  cursor: 'pointer',

  '&:hover': {
    color: token('color.text.selected'),
    textDecoration: 'none',
  },
  '&:active': {
    color: '#0055CC',
    li: {
      background: token('color.background.accent.blue.subtlest'),
    },
  },
});

const activeStyles = css({
  color: token('color.text.selected'),
});
